import { LOCALE_ID, NgModule } from '@angular/core';
import { UploadModule } from '@progress/kendo-angular-upload';
import { IntlModule } from '@progress/kendo-angular-intl';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
//import { SortableModule } from '@progress/kendo-angular-sortable';
import { PopupModule } from '@progress/kendo-angular-popup';
//import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { DialogModule, DialogsModule } from '@progress/kendo-angular-dialog';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { ChartsModule } from "@progress/kendo-angular-charts";
import { PopoverModule } from "@progress/kendo-angular-tooltip";
// Load all required data for the bg locale
import "@progress/kendo-angular-intl/locales/fr/all";
import { NotificationModule } from '@progress/kendo-angular-notification';
import { PDFViewerModule } from '@progress/kendo-angular-pdfviewer';
import { IconsModule } from '@progress/kendo-angular-icons';
import { GaugesModule } from "@progress/kendo-angular-gauges";

@NgModule({
  declarations: [],
  exports: [
    UploadModule,
    IntlModule,
    GridModule,
    ExcelModule,
    InputsModule,
    DateInputsModule,
    ButtonsModule,
    DropDownsModule,
    ContextMenuModule,
    NotificationModule,
    //SortableModule,
    //ContextMenuModule,
    TreeViewModule,
    ListViewModule,
    PopupModule,
    LayoutModule, 
    IndicatorsModule, 
    DialogModule, 
    PopoverModule,
    ChartsModule, 
    GaugesModule,
    DialogsModule,
    PDFViewerModule, 
    IconsModule,
  ],
  providers: [
    {
      // Set default locale to bg-BG
      provide: LOCALE_ID,
      useValue: "fr-FR",
    },
  ]
  
})
export class KendoModule {}
